// Core
import CoreMetrics, {createExpandableMediaQueryStylesheet} from '../core/Metrics';

const Styles = createExpandableMediaQueryStylesheet({
    gridWidthFull: {
        flex: 1,
    },
    gridWidthOneHalf: {
        flexShrink: 0,
        width: CoreMetrics.Grid.Width.OneHalf,
    },
    gridWidthOneThird: {
        flexShrink: 0,
        width: CoreMetrics.Grid.Width.OneThird,
    },
    gridWidthOneFourth: {
        flexShrink: 0,
        width: CoreMetrics.Grid.Width.OneFourth,
    },
    gridWidthOneSixth: {
        flexShrink: 0,
        width: CoreMetrics.Grid.Width.OneSixth,
    },
    gridWidthOneEighth: {
        flexShrink: 0,
        width: CoreMetrics.Grid.Width.OneEighth,
    },
    gridWidthOneNinth: {
        flexShrink: 0,
        width: CoreMetrics.Grid.Width.OneNinth,
    },
    gridWidthOneTwelfth: {
        flexShrink: 0,
        width: CoreMetrics.Grid.Width.OneTwelfth,
    },
    hairlineInnerStroke: {
        boxShadow: "inset 0 0 0 1px " + CoreMetrics.Color.Hairline,
        [CoreMetrics.MediaQuery().RetinaDevice]: {
            boxShadow: "inset 0 0 0 0.5px " + CoreMetrics.Color.HairlineRetina,
        }
    },
    hairlineOuterStroke: {
        boxShadow: ["1px 0 " + CoreMetrics.Color.Hairline,
                    "-1px 0 " + CoreMetrics.Color.Hairline,
                    "0 1px " + CoreMetrics.Color.Hairline,
                    "0 -1px " + CoreMetrics.Color.Hairline].join(", "),
        [CoreMetrics.MediaQuery().RetinaDevice]: {
            boxShadow: ["0.5px 0 " + CoreMetrics.Color.HairlineRetina,
                        "-0.5px 0 " + CoreMetrics.Color.HairlineRetina,
                        "0 0.5px " + CoreMetrics.Color.HairlineRetina,
                        "0 -0.5px " + CoreMetrics.Color.HairlineRetina].join(", "),
        }
    },
    hairlineStrokeTopAndBottom: {
        boxShadow: ["0 -1px " + CoreMetrics.Color.Hairline,
                    "0 1px " + CoreMetrics.Color.Hairline].join(", "),
        [CoreMetrics.MediaQuery().RetinaDevice]: {
            boxShadow: ["0 -0.5px " + CoreMetrics.Color.HairlineRetina,
                      "0 0.5px " + CoreMetrics.Color.HairlineRetina].join(", "),
        }
    },
    hairlineStrokeTop: {
        boxShadow: "0 -1px " + CoreMetrics.Color.Hairline,
        [CoreMetrics.MediaQuery().RetinaDevice]: {
            boxShadow: "0 -0.5px " + CoreMetrics.Color.HairlineRetina,
        }
    },
    hairlineStrokeBottom: {
        boxShadow: "0 1px " + CoreMetrics.Color.Hairline,
        [CoreMetrics.MediaQuery().RetinaDevice]: {
            boxShadow: "0 0.5px " + CoreMetrics.Color.HairlineRetina,
        }
    },
    hairlineStrokeRight: {
        boxShadow: "1px 0 " + CoreMetrics.Color.Hairline,
        [CoreMetrics.MediaQuery().RetinaDevice]: {
            boxShadow: "0.5px 0 " + CoreMetrics.Color.HairlineRetina,
        }
    },
    dropShadow: {
        boxShadow: ["1px 0 " + CoreMetrics.Color.Hairline,
                    "-1px 0 " + CoreMetrics.Color.Hairline,
                    "0 1px " + CoreMetrics.Color.Hairline,
                    "0 -1px " + CoreMetrics.Color.Hairline,
                    "0 1px 4px " + CoreMetrics.Color.Shadow].join(", "),
        [CoreMetrics.MediaQuery().RetinaDevice]: {
            boxShadow: ["0.5px 0 " + CoreMetrics.Color.HairlineRetina,
                        "-0.5px 0 " + CoreMetrics.Color.HairlineRetina,
                        "0 0.5px " + CoreMetrics.Color.HairlineRetina,
                        "0 -0.5px " + CoreMetrics.Color.HairlineRetina,
                        "0 1px 4px " + CoreMetrics.Color.Shadow].join(", "),
        }
    },
    PlaceholderText: {
        color: CoreMetrics.Color.LightUI.PlaceholderText,
    },
});

const CoreStyles = Styles;
export default CoreStyles;



// WEBPACK FOOTER //
// ./src/core/Styles.js